import { useInfiniteQuery } from "@tanstack/react-query";
import { useAxios } from "../../../api/axios";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";

export const useNotificationsInfinite = () => {
  const axios = useAxios();
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();

  const limit = Number(searchParams.get("limit") || 10);

  return useInfiniteQuery({
    queryKey: [
      "calling-pipeline-notifications-infinite",
      searchParams.toString()
    ],
    queryFn: async ({ pageParam = 1 }) => {
      const urlKey = t("calling-pipeline-notifications");
      const response = await axios.get(urlKey, {
        params: {
          page: pageParam,
          limit
        }
      });
      // API shape: { data: { data: [...], total, page, limit } }
      return response.data.data;
    },
    initialPageParam: 1,
    getNextPageParam: (lastPage: any) => {
      const { total, page, limit } = lastPage || {};
      if (!total || !page || !limit) return undefined;
      const totalPages = Math.ceil(total / limit);
      return page < totalPages ? page + 1 : undefined;
    },
    refetchOnWindowFocus: false
  });
};


